import Proposals from 'assets/icons/fa/scroll.svg'

export default Proposals
